import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Apollo } from 'apollo-angular';
import { getMinute } from './querys';


export class actividades{
  public name?: string;
  public initial_date?: Date;
  public end_date?: Date;
  public minuteId?: number;
  public responsibleId?: number;
}

export class ponderacion{
  projectWeighing?: number;
}

export class historico{
  period?: string;
  planned?: number;
  executed?: number;
  activityId?: Number;
}
export class Adicionales{
  activityId?: Number;
  name?: string;
  amount?: Number;
  files?: string;
  note?: string;
  type?: string;
} 

export class actas{
  name?: string;
  validatorId?: number;
  description?: string;
  attachment?: string;
  planId?:  number;
}
export class envioActa{
  responsibleIds?: Number[];
}

export class comment{
  additionalId?: Number
  comment?: string;
  createdAt?: String;
}

@Injectable({
  providedIn: 'root'
})
export class PlanesService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private headersAr = new HttpHeaders().append('enctype', 'multipart/form-data')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private http: HttpClient,
    private cookies: CookieService,
    private readonly apollo: Apollo,
  ) { }

  /* Actas */
  public getActas(): Observable<any>{
    const apiURL = this.apiURL+"actas";
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }
  public async getActasGql(id: string) {
    const allData: any[] = [];
    let currentPage = 1;
    let hasNextPage = true;

    while (hasNextPage) {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
          query: getMinute,
          context: { headers: this.headers },
          variables: {
            args: {
              filter: {
                conditions: [
                  {
                    operator: "EQUAL",
                    field: "planId",
                    value: id
                  }
                ]
              },
              pagination: {
                page: currentPage
              }
            }
          },
          fetchPolicy: 'no-cache'
        }).valueChanges
      );

      const { data: minutes, metadata } = data.searchMinutes;
      allData.push(...minutes);

      hasNextPage = metadata.hasNextPage;
      currentPage++;
    }

    return allData;
  }
  public async getActaByIdGql(id: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getMinute,
        context: {headers: this.headers},
        variables: {
          "args": {
            "filter": {
              "conditions": [
                {
                  "field": "id",
                  "operator": "EQUAL",
                  "value": id
                }
              ]
            }
          }
        },
        fetchPolicy: 'no-cache'
      }).valueChanges
    );
    return data.searchMinutes.data[0];
  }
  public postActas(acta): Observable<any>{
    const formData: FormData = new FormData();
    formData.append('description', acta.descripcion);
    formData.append('validatorId', acta.responsableId);
    formData.append('name', acta.nombre);
    formData.append('planId', acta.planId);
    if(acta.archivo !== undefined){
      formData.append('attachment', acta.archivo);
    }

    const apiURL = this.apiURL+"actas";
    return this.http.post(`${apiURL}`, formData, {headers: this.headersAr});
  }
  public patchActas(acta): Observable<any>{
    var actaEdit: actas = {
      name: acta.nombre,
      validatorId: Number(acta.responsableId),
      description: acta.descripcion,
      planId: Number(acta.planId),
    };

    const body = JSON.stringify(actaEdit);
    const apiURL = this.apiURL+"actas/"+acta.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public patchActasfile(acta): Observable<any>{
    const formData: FormData = new FormData();
    formData.append('name', acta.nombre);
    formData.append('attachment', acta.archivo);
    const apiURL = this.apiURL+"actas/"+acta.id;
    return this.http.patch(`${apiURL}`, formData, {headers: this.headersAr});
  }
  public deleteActas(acta: any): Observable<any>{
    const apiURL = this.apiURL+"actas/"+acta.id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
  public envioActas(responsables: any, actaId: number): Observable<any>{
    var enviar: envioActa = {
      responsibleIds: responsables,
    };

    const body = JSON.stringify(enviar);
    const apiURL = this.apiURL+"actas/"+actaId+"/enviar";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  /* Actividades Actas */
  public getActividadesActas(): Observable<any>{
    const apiURL = this.apiURL+"acta/actividades";
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }
  public postActividades(act: any): Observable<any>{
    const acti: actividades = {
      minuteId: Number(act.id),
      initial_date: act.fechaIni,
      end_date: act.fechaFin,
      name: act.nombre,
      responsibleId: Number(act.responsableId),
    }

    const body = JSON.stringify(acti);
    const apiURL = this.apiURL+"acta/actividades";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public patchActividades(act: any): Observable<any>{
    const acti: actividades = {
      initial_date: act.fechaIni,
      end_date: act.fechaFin,
      name: act.nombre,
      responsibleId: Number(act.responsableId),
    }

    const body = JSON.stringify(acti);
    const apiURL = this.apiURL+"acta/actividades/"+act.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public deleteActividades(actividad: any): Observable<any>{
    const apiURL = this.apiURL+"acta/actividades/"+actividad.id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
  public deleteHistory(his: any): Observable<any>{
    const apiURL = this.apiURL+"acta/actividad/historic/"+his.id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
  /** Historico */
  public postHistorico(his: any, idAct: number): Observable<any>{
    const hist: historico = {
      activityId: idAct,
      period: his.periodo,
      planned: Number(his.planeado),
      executed: his.ejecutado,
    }
    const body = JSON.stringify(hist);
    const apiURL = this.apiURL+"acta/actividad/historic";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public PatchHistorico(his: any, idHis: number): Observable<any>{
    const hist: historico = {
      executed: his.ejecutado,
    }
    const body = JSON.stringify(hist);
    const apiURL = this.apiURL+"acta/actividad/historic/"+idHis;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public deleteHistorico(his: any): Observable<any>{
    const apiURL = this.apiURL+"acta/actividad/historic/"+his.id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
  public PatchHistoricoNull(his: any, idAct: number, idHis: number): Observable<any>{
    const hist: historico = {
      period: his.period,
      planned: Number(his.planned),
      executed: his.executed,
    }
    const body = JSON.stringify(hist);
    const apiURL = this.apiURL+"actividad/"+idAct+"/history/"+idHis;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  //Adicionales
  public postAdicionales(adicional: any): Observable<any>{
    const ad: Adicionales = {
      activityId: Number(adicional.activityId),
      name: adicional.name,
      type: adicional.type,
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"acta/actividad/adicionales";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public patchAdicionales(adicional: any, id: any): Observable<any>{
    const ad: Adicionales = {
      amount: Number(adicional.amount),
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"acta/actividad/adicionales/"+adicional.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public patchAdicionalesN(adicional: any, id: any): Observable<any>{
    const ad: Adicionales = {
      note: adicional.note,
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"acta/actividad/adicionales/"+adicional.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public patchAdicionalesNombre(adicional: any): Observable<any>{
    const ad: Adicionales = {
      name: adicional.name,
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"acta/actividad/adicionales/"+adicional.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public deleteAdicional(adicional: any): Observable<any>{
    const apiURL = this.apiURL+"acta/actividad/adicionales/"+Number(adicional.id);
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  /* Adicionales comentarios */
  public postComment(com: any, idAct: number): Observable<any>{
    const coment: comment = {
      additionalId: Number(idAct),
      comment: com.comment,
      createdAt: com.createdAt,
    }
    const body = JSON.stringify(coment);
    const apiURL = this.apiURL+"acta/actividad/adicional/comentarios";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public patchComment(com: any, idAct: number): Observable<any>{
    const coment: comment = {
      comment: com.comment,
    }
    const body = JSON.stringify(coment);
    const apiURL = this.apiURL+"acta/actividad/adicional/comentarios/"+Number(com.id);
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public deleteComment(com: any): Observable<any>{
    const apiURL = this.apiURL+"acta/actividad/adicional/comentarios/"+Number(com.id);
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  /* Archivos */
  public postFile(fil: any, idAd: number, fecha: any): Observable<any>{
    const formData: FormData = new FormData();
    formData.append('additionalId', ''+idAd);
    formData.append('file', fil);
    formData.append('createdAt', fecha);

    const apiURL = this.apiURL+"acta/actividad/adicional/adjuntos";
    return this.http.post(`${apiURL}`, formData, {headers: this.headersAr});
  }
  public getFile(idAd: any, idFil: any): Observable<any>{
    const apiURL = this.apiURL+"acta/actividad/adicional/adjuntos/"+idFil;
    return this.http.get(`${apiURL}`, {headers: this.headers, 'responseType'  : 'arraybuffer' as 'json'});
  }
  public deleteFile(idAd: any, idFil: any): Observable<any>{
    const apiURL = this.apiURL+"acta/actividad/adicional/adjuntos/"+idFil;
    return this.http.delete(`${apiURL}`, {headers: this.headers, 'responseType'  : 'arraybuffer' as 'json'});
  }
  public getFileActas(acta): Observable< any >{
    const apiURL = this.apiURL+"actas/"+acta.id+"/file";
    return this.http.get(`${apiURL}`, {headers: this.headers, 'responseType'  : 'arraybuffer' as 'json'});
  }
}
